/**
 * @fileoverview gRPC-Web generated client stub for reorgpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: reportpb/stockborrow.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.reorgpb = require('./stockborrow_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reorgpb.StockBorrowServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reorgpb.StockBorrowServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reorgpb.ListStockBorrowRequest,
 *   !proto.reorgpb.ListStockBorrowResponse>}
 */
const methodDescriptor_StockBorrowService_ListStockBorrow = new grpc.web.MethodDescriptor(
  '/reorgpb.StockBorrowService/ListStockBorrow',
  grpc.web.MethodType.UNARY,
  proto.reorgpb.ListStockBorrowRequest,
  proto.reorgpb.ListStockBorrowResponse,
  /**
   * @param {!proto.reorgpb.ListStockBorrowRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.ListStockBorrowResponse.deserializeBinary
);


/**
 * @param {!proto.reorgpb.ListStockBorrowRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reorgpb.ListStockBorrowResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reorgpb.ListStockBorrowResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reorgpb.StockBorrowServiceClient.prototype.listStockBorrow =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reorgpb.StockBorrowService/ListStockBorrow',
      request,
      metadata || {},
      methodDescriptor_StockBorrowService_ListStockBorrow,
      callback);
};


/**
 * @param {!proto.reorgpb.ListStockBorrowRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reorgpb.ListStockBorrowResponse>}
 *     Promise that resolves to the response
 */
proto.reorgpb.StockBorrowServicePromiseClient.prototype.listStockBorrow =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reorgpb.StockBorrowService/ListStockBorrow',
      request,
      metadata || {},
      methodDescriptor_StockBorrowService_ListStockBorrow);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reorgpb.ListStockBorrowDetailRequest,
 *   !proto.reorgpb.ListStockBorrowDetailResponse>}
 */
const methodDescriptor_StockBorrowService_ListStockBorrowDetail = new grpc.web.MethodDescriptor(
  '/reorgpb.StockBorrowService/ListStockBorrowDetail',
  grpc.web.MethodType.UNARY,
  proto.reorgpb.ListStockBorrowDetailRequest,
  proto.reorgpb.ListStockBorrowDetailResponse,
  /**
   * @param {!proto.reorgpb.ListStockBorrowDetailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reorgpb.ListStockBorrowDetailResponse.deserializeBinary
);


/**
 * @param {!proto.reorgpb.ListStockBorrowDetailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reorgpb.ListStockBorrowDetailResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reorgpb.ListStockBorrowDetailResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reorgpb.StockBorrowServiceClient.prototype.listStockBorrowDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reorgpb.StockBorrowService/ListStockBorrowDetail',
      request,
      metadata || {},
      methodDescriptor_StockBorrowService_ListStockBorrowDetail,
      callback);
};


/**
 * @param {!proto.reorgpb.ListStockBorrowDetailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reorgpb.ListStockBorrowDetailResponse>}
 *     Promise that resolves to the response
 */
proto.reorgpb.StockBorrowServicePromiseClient.prototype.listStockBorrowDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reorgpb.StockBorrowService/ListStockBorrowDetail',
      request,
      metadata || {},
      methodDescriptor_StockBorrowService_ListStockBorrowDetail);
};


module.exports = proto.reorgpb;

